<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择单位"
      width="800px"
      top="5vh">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="units"
        @select="selectUnit"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="编号" prop="unitNo">
            <el-input v-model.trim="filter.unitNo" placeholder="请输入单位编号" clearable/>
          </el-form-item>
          <el-form-item label="名称" prop="unitName">
            <el-input v-model.trim="filter.unitName" placeholder="请输入单位名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {
          unitNo: "",
          unitName: "",
        },
        columns: [
          {
            title: "编号",
            key: "unitNo",
            width: 100,
            align: "center",
          },
          {
            title: "名称",
            key: "unitName",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },

      selectUnit(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
        this.$refs.tableSelect.loadData();
      },
    },
  };
</script>
